import { Grid } from '@material-ui/core';
import { ModalContext } from '../../context';
import { PrimaryButton } from '@/styles/blocks';
import { TabRow, TabTitle } from '@/components/ShipmentForm/blocks';
import HaulAwayItem from './HaulAwayItem';
import React, { useState, useContext } from 'react';
import { css } from '@emotion/react';

/**
 * Haulaways section of the Edit Order modal: one row per haul-away item plus Add Item.
 * Takes no props; reads `ModalContext`.
 */
const ItemsEditModal = () => {
    const { state: modalState, callbacks } = useContext(ModalContext);
    const { order } = modalState;
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <TabTitle collapsed={collapsed} callbacks={{ setCollapsed }}>
                Haulaways
            </TabTitle>
            {collapsed ? null : (
                <>
                    {(order.haulaway_items || []).map((item, idx) => (
                        <HaulAwayItem key={idx} order={order} item={item} index={idx} callbacks={callbacks} />
                    ))}

                    <TabRow>
                        <Grid item>
                            <PrimaryButton onClick={() => callbacks.addItem({ type: 'haulaway' })}>
                                Add Item
                            </PrimaryButton>
                        </Grid>
                    </TabRow>
                </>
            )}
        </>
    );
};

export default ItemsEditModal;
